<template>
  <NavbarOne />
  <PageBanner
    pageTitle="التصنيفات"
    subTitle="استعرض جميع تصنيفات المقالات والشروحات المتعلقة بخدمات IPTV والقنوات العربية والأفلام والمسلسلات لتصل إلى المحتوى الذي يهمك بسهولة."
    :pageBannerImage="pageBannerImg"
  />
  <Categories />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import Categories from "@/components/Categories/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "CategoriesPage",
  components: {
    NavbarOne,
    PageBanner,
    Categories,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "تصنيفات المقالات | IPTV والقنوات العربية والأفلام",
      meta: [
        {
          name: "description",
          content:
            "تصفح جميع تصنيفات المقالات الخاصة بخدمات IPTV، القنوات العربية، الأفلام، المسلسلات، الشروحات التقنية، وأحدث الأخبار لتصل بسرعة إلى المحتوى الذي تبحث عنه.",
        },
        {
          name: "keywords",
          content:
            "تصنيفات IPTV, مقالات IPTV, شروحات IPTV, قنوات عربية, أفلام, مسلسلات, دليل IPTV, أخبار IPTV",
        },
        {
          property: "og:title",
          content: "تصنيفات المقالات | IPTV والقنوات العربية والأفلام",
        },
        {
          property: "og:description",
          content:
            "استعرض جميع تصنيفات المقالات والشروحات المتعلقة بخدمات IPTV والقنوات العربية والأفلام والمسلسلات.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/categories",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-6.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>